import styles from './ItemTax.css'

class ItemTax extends React.Component {
  componentWillMount () {
    const {fields, taxes, itemDetail} = this.props
    if (itemDetail.id === null) { // In create mode, confirm using itemId === null, so set as checked
      taxes.forEach((tax) => {
        fields.push(tax)
      })
    }
  }

  render () {
    const {taxes, itemDetail} = this.props
    return (<div>
      {taxes.map((tax, index) =>
        <div className={`row ${styles['row-wrapper']}`}>
          <div className={`col-xs-10 ${styles['tax-name-wrapper']}`}>
            <a href='#' onClick={(e) => this._onTextClick(e, tax.id)}>{tax.name}</a>
          </div>
          <div className={`col-xs-2 ${styles['tax-checkbox-wrapper']}`}>
            <div className={`checkbox ${styles['checkbox-moka']}`}>
              <input
                className={`pull-right ${styles['tax-checkbox-input']}`}
                type='checkbox'
                checked={this._checked(tax.id, itemDetail)}
                onChange={(e) => this._onChangeCheckbox(e, tax.id)}
                id={`tax-${tax.id}`}
              />
              <label className={`float-left ${styles['tax-amount-label']}`} for={`tax-${tax.id}`}>{tax.amount}%</label>
            </div>
          </div>
        </div>
      )}
    </div>)
  }

  _onTextClick = (e, id) => {
    e.preventDefault()
    e.stopPropagation()
    this._onChangeCheckbox(e, id)
  }

  _onChangeCheckbox = (e, id) => {
    const {fields, taxes} = this.props
    const values = fields.getAll()
    let indexPosition = -1
    values.forEach((value, index) => {
      if (value.id === id) {
        indexPosition = index
      }
    })
    if (indexPosition === -1) {
      // the value doesn't exist, insert data
      taxes.forEach((tax) => {
        if (tax.id === id) {
          fields.push(tax)
        }
      })
    } else {
      // remove the value
      fields.remove(indexPosition)
    }
  }

  _checked = (id, itemDetail) => {
    const {fields} = this.props
    const values = fields.getAll()
    let checked = false
    if (values) {
      values.forEach((val) => {
        checked = checked || (val.id === id)
      })
    }
    return checked
  }
}

export default ItemTax



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemTax/ItemTax.js